import './App.css';
import React, { useState, useEffect } from "react";
import Header from './layout/header';
import Content from './layout/content';
import Footer from './layout/footer';

const App = () => {
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  return (
    <div className={`${isDarkMode ? "bg-[#212529] text-white" : "bg-white text-black"}`}>
      <Header toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
      <Content isDarkMode={isDarkMode} />
      <Footer isDarkMode={isDarkMode} />
    </div>
  );
};

export default App;